import React from "react";
import { Tenant } from "@commr/admin/models/tenant";
import ResidenciesContainer from "../../components/residencies/residenciesContainer";

const ResidenciesPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <ResidenciesContainer tenant={new Tenant()} />
);

export default ResidenciesPage;
